import React, { useEffect, useMemo, useState } from "react";
import "../ShiftTask/CreateShiftTask.css";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { currentCareSiteId } from "../../redux-toolkit/reducer/switchSites";
import { timeValues } from "../../constants/constants";
import { httpAdmin } from "../../Apis/commonApis";
import { getFullName } from "../../utils/CommonFunctions";
import { ShowSwal } from "../../utils/alertSwal";

const EditCreateShiftTask = (props) => {
  const { editTaskData } = props;
  const shiftData = editTaskData?.ShiftData;
  // console.log(editTaskData, 'editTaskData---------')

  const openShiftType = shiftData?.shiftMappings?.length > 0 ? 'assigned' : 'open'

  let updateData;
  if (props.typeshift == "generic") {
    updateData = props?.editTaskData;
  } else if (props.typeshift == "client") {
    updateData = props?.editTaskData;
  } else {
    updateData = props?.editTaskData?.ShiftData;
  }
  console.log(editTaskData, 'tttttttttttteeeeeeeeeeee')

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
    setValue,
    dirtyFields,
    clearErrors,
  } = useForm({
    defaultValues: {
      shiftname: updateData?.shiftName,
      date: updateData?.Date,
      startTime: shiftData?.startingTime,
      endTime: shiftData?.endingTime,
      endDate: updateData?.endDate,
      recurringshift: updateData.recurringShiftType,
      weekdays: updateData?.recurringTasktype
        ? updateData?.recurringTasktype.split(",")
        : [],
      shiftType: openShiftType ?? updateData.recurringShiftType,
      assign_to: updateData?.careTeamMember,
    },
  });

  let buttonText;
  if (props.buttonType === "editGenericTemplate") {
    buttonText = "Update Template";
  } else if (props.buttonType === "editClientTemplate") {
    buttonText = "Update Template";
  } else {
    buttonText = props.typeshift === "" ? "Update Shift" : "Create Shift";
  }

  const todayTime = `${
    new Date().getHours() < 10 ? "0" : ""
  }${new Date().getHours()}:${
    new Date().getMinutes() < 10 ? "0" : ""
  }${new Date().getMinutes()}`;

  //assign To values
  const [assignedCareTeamData, setAssignedCareTeamData] = useState([]);

  //post shift data
  const [instruction, setinstruction] = useState(updateData?.instruction);

  const [selectedDays, setSelectedDays] = useState(
    shiftData?.recurringTasktype ? shiftData?.recurringTasktype.split(",") : []
  );

  const [filteredResultsTeam, setFilteredResultsTeam] = useState([]);
  const [status, setStatus] = useState(updateData?.recurringTask ? 1 : 2); // 0: no show, 1: show yes, 2: show no.
  const [shiftType, setShiftType] = useState(openShiftType ?? updateData.recurringShiftType);
  const [isAddTaskValid, setIsAddTaskValid] = useState(false);

  useEffect(() => {
    // console.log(editTaskData, "editTaskData");
    if (shiftData) {
      setValue("priorityBasedOnType", shiftData?.priorityBasedOn);
      setValue("date", shiftData?.Date || "");
      setValue("startTime", shiftData?.startingTime ?? "");
      setValue("endTime", shiftData?.endingTime ?? "");
      setBeforedate(shiftData?.Date);
      const shiftMappingData = editTaskData?.ShiftData?.shiftMappings;
      if (shiftData?.recurringShiftType === "assigned" || shiftMappingData?.length > 0) {
        const assignedCareMembers = shiftMappingData?.map(
          (item) => {
            const careteam = item.careteam;
            return {
              value: careteam?._id,
              label: (
                <div>
                  <img src={careteam?.image} height="30px" width="30px" />{" "}
                  {getFullName(careteam)}
                </div>
              ),
              name: getFullName(careteam),
            };
          }
        );
        setAssignedCareTeamData(assignedCareMembers);
      }
    }
  }, [editTaskData]);

  const editshift = async (event) => {
    const finalData = [];
    if (shiftType === "open" || shiftType === "unassigned") {
      finalData.push({
        careHomeId: currentCareSiteId,
        clientId: editTaskData?.client?._id,
        shiftId: props?.data?.EditShiftData?.id,
        Date: event.date,
        startingTime: event.startTime,
        endingTime: event.endTime,
        recurringTask: false,
        recurringTasktype: selectedDays.join(","),
        instruction: instruction,
        recurringShiftType: shiftType,
        templateType: "",
        priorityBasedOn: getValues("priorityBasedOnType")
          ? getValues("priorityBasedOnType")
          : event.priorityBasedOnType,
      });
    } else {
      const assignedTeams = assignedCareTeamData?.map((item) => item.value);
      if (assignedTeams?.length === 0) {
        ShowSwal(false, "Please select cateteam!");
        return;
      }
      finalData.push({
        careHomeId: currentCareSiteId,
        shiftId: props?.data?.EditShiftData?.id,
        clientId: editTaskData?.client?._id,
        careTeamId: assignedTeams,
        Date: event.date,
        startingTime: event.startTime,
        endingTime: event.endTime,
        recurringTask: false,
        recurringTasktype: selectedDays.join(","),
        instruction: instruction,
        templateType: "",
        priorityBasedOn: getValues("priorityBasedOnType")
          ? getValues("priorityBasedOnType")
          : event.priorityBasedOnType,
        recurringShiftType: shiftType,
      });
    }

    const apiEnd = "createShift?type=edit";
    const res = await httpAdmin(apiEnd, "post", finalData, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      props.getShiftsandtaskNew("closePopup");
    }
    // var data = new FormData();
    // data.append("shiftId", props?.data?.EditShiftData?.id);
    // data.append("shiftdata", JSON.stringify(shiftdata));
  };

  const showField = (e) => {
    if (e === "assigned") {
      handleSubmit((data) => {
        if (Object.keys(errors).length === 0) {
          setShiftType(e);
        }
        handleShiftSelect();
      })();
    } else {
      setShiftType(e);
    }
  };

  function handleShiftSelect() {
    let startDate = getValues("date");
    let endDate;
    if (status === 1) getValues("endDate");

    const numberArray = selectedDays.map((day) => {
      switch (day) {
        case "Mon":
          return 1;
        case "Tue":
          return 2;
        case "Wed":
          return 3;
        case "Thu":
          return 4;
        case "Fri":
          return 5;
        case "Sat":
          return 6;
        case "Sun":
          return 0;
        default:
          return -1; // If an invalid day is encountered
      }
    });

    let result = getDatesOfSelectedDays(startDate, endDate, numberArray);

    let shiftDates = [];
    result.forEach((elem) => {
      shiftDates.push({
        date: elem?.split("T")[0],
        startTime: getValues("startTime"),
        endTime: getValues("endTime"),
      });
    });
    if (shiftDates.length > 0) getAvailableCareTeam(shiftDates);
  }

  const getAvailableCareTeam = async (shiftArray) => {
    let startDate = new Date(getValues("date"))?.toISOString();
    let endDate = new Date(getValues("endDate"));
    const priorityValue = getValues("priorityBasedOnType");
    let data = {
      careSiteId: currentCareSiteId,
      shiftDates: shiftArray,
      clientId: editTaskData?.client?._id,
      priorityBasedOn: priorityValue ?? "weeklyHoursAssigned",
      startDate: startDate,
      endDate: shiftArray.length > 1 ? endDate.toISOString() : startDate,
    };
    const response = await httpAdmin("availableCareMember", "post", data, null);
    let filteredData = [];
    const priorityUnits = {
      performance: "%",
      distance: "miles",
      weeklyHoursAssigned: "Hrs",
    };
    response?.data?.forEach((elem) => {
      const criteriaValue =
        priorityValue === "distance"
          ? elem.distance
          : priorityValue === "performance"
          ? elem.averagePerformance
          : elem.totalHours;
      filteredData.push({
        value: elem?._id,
        sortValue: criteriaValue,
        label: (
          <div>
            <img src={elem?.image} height="30px" width="30px" />{" "}
            <span>{getFullName(elem)}</span>
            <span style={{ fontSize: "10px" }}>
              ({criteriaValue?.toFixed(2)}
              {priorityUnits[priorityValue]})
            </span>
            {/* {elem?.first_Name + " " + elem?.last_Name}{" "} */}
          </div>
        ),
        name: getFullName(elem),
        // `${elem.first_Name} ${elem.last_Name}`,
      });
    });
    const sortByAsc =
      priorityValue === "performance"
        ? sortArrayByKeyDesc(filteredData, "sortValue")
        : sortArrayByKeyAsc(filteredData, "sortValue");
    setFilteredResultsTeam(sortByAsc);
  };

  function getDatesOfSelectedDays(startDate, endDate, selectedDay) {
    let dates = [];
    let currentDate = new Date(startDate);

    if (!endDate) {
      dates.push(new Date(startDate).toISOString());
      return dates;
    }

    while (currentDate <= new Date(endDate)) {
      if (selectedDay.includes(currentDate.getDay())) {
        dates.push(new Date(currentDate).toISOString());
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  }

  const handleCareteamSelect = (event) => {
    setAssignedCareTeamData(event);
  };

  const today = new Date().toISOString().split("T")[0];

  let editClient = {};
  if (props.typeshift == "client" || props.typeshift == "") {
    editClient = editTaskData?.client;
  }

  const [beforeDate, setBeforedate] = useState("");

  useEffect(() => {
    if (watch("startTime", "") > watch("endTime", "")) {
      setValue("endTime", "");
    }
  }, [watch("startTime", "")]);

  return (
    <>
      <div className="card">
        <form onSubmit={handleSubmit(editshift)}>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                {props.titleName !== "Shift Creation" && (
                  <div className="row form_box align-items-center mb-3">
                    <label className="form-label col-md-4 mb-0">
                      Shift Name:
                    </label>
                    <div className="col-md-8">
                      <div className="position-relative">
                        <input
                          autoComplete="off"
                          type="text"
                          // value={shiftName}
                          // onChange={(e) => setshiftName(e.target.value)}
                          className="form-control keytype"
                          name="shiftname"
                          {...register("shiftname", {
                            required:
                              props.titleName !== "Shift Creation"
                                ? true
                                : false,
                            // onChange: (e) => {
                            //   setshiftName(e.target.value);
                            // },
                          })}
                        />
                        {errors.shiftname && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {props.buttonType !== "editGenericTemplate" && (
                  <div className="row form_box align-items-center mb-3">
                    <label className="form-label col-md-4 mb-0">For:</label>
                    <div className="col-md-8">
                      <div className="position-relative">
                        {(props.typeshift == "client" ||
                          props.typeshift == "") && (
                          <Select
                            value={{
                              value: editClient?._id,
                              label: (
                                <div>
                                  <img
                                    src={editClient?.image}
                                    height="30px"
                                    width="30px"
                                  />{" "}
                                  {getFullName(editClient)}{" "}
                                  {/* {editClient?.first_Name + " " + editClient?.last_Name}{" "} */}
                                </div>
                              ),
                              name: getFullName(editClient),
                            }}
                            isDisabled={true}
                          />
                        )}

                        {errors.for && (
                          <span className="error_style">
                            This field is required
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="row form_box align-items-center mb-3">
                  <label className="form-label col-md-4 mb-0">
                    Date{" "}
                    {props.titleName !== "Shift Creation" ? "(Optional)" : ""}:
                  </label>
                  <div className="col-md-8">
                    <input
                      type="date"
                      name="date"
                      min={today}
                      className="form-control"
                      {...register("date", {
                        required:
                          props.titleName !== "Shift Creation" ? true : false,
                        onChange(e) {
                          setBeforedate(e.target.value);
                        },
                      })}
                    />
                    {errors.date && (
                      <span style={{ color: "red" }}>
                        This field is required
                      </span>
                    )}
                  </div>
                </div>
                {/*  */}
                <div className="row form_box align-items-center mb-3">
                  <label className="form-label col-md-4 mb-0">
                    Starting Time:
                  </label>
                  <div className="col-md-8">
                    <select
                      className="form-select custom_timeInput"
                      name="startTime"
                      {...register("startTime", { required: true })}
                    >
                      {timeValues
                        // .filter((item) =>
                        //   beforeDate <= today ? item.value > todayTime : true
                        // )
                        .map((item) => {
                          return (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          );
                        })}
                    </select>
                    {errors.startTime && (
                      <span style={{ color: "red" }}>
                        This field is required
                      </span>
                    )}
                  </div>
                </div>
                <div className="row form_box align-items-center mb-3">
                  <label className="form-label col-md-4 mb-0">
                    Ending Time:
                  </label>
                  <div className="col-md-8">
                    <select
                      name="endTime"
                      className="form-select custom_timeInput"
                      {...register("endTime", { required: true })}
                    >
                      {timeValues
                        .filter((item) => {
                          return item.value > watch("startTime", "");
                        })
                        .map((item) => {
                          return (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          );
                        })}
                    </select>
                    {errors.endTime && (
                      <span style={{ color: "red" }}>
                        This field is required
                      </span>
                    )}
                  </div>
                </div>
                {/*  */}
                <div className="row form_box align-items-center mb-3 mt-2">
                  <label className="form-label col-md-4 mb-0">
                    CareTeam Selection Criteria:
                  </label>
                  <div className="col-md-8">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="priorityRadioOptions"
                        id="priorityRadio1"
                        {...register("priorityBasedOnType", {
                          required: true,
                        })}
                        value="weeklyHoursAssigned"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="priorityRadio1"
                      >
                        Weekly Hours Assigned
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="priorityRadioOptions"
                        id="priorityRadio2"
                        value="distance"
                        {...register("priorityBasedOnType", {
                          required: true,
                        })}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="priorityRadio2"
                      >
                        Distance
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="priorityRadioOptions"
                        id="priorityRadio3"
                        value="performance"
                        {...register("priorityBasedOnType", {
                          required: true,
                        })}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="priorityRadio3"
                      >
                        Performance
                      </label>
                    </div>
                    {errors.priorityBasedOnType && (
                      <span style={{ color: "red" }}>
                        This field is required
                      </span>
                    )}
                  </div>
                </div>
                {props.titleName === "Shift Creation" && (
                  <div className="row form_box align-items-center mb-3 mt-2">
                    <label className="form-label col-md-4 mb-0">
                      Shift Assignment:
                    </label>
                    <div className="col-md-8">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio1"
                          {...register("shiftType", { required: true })}
                          value="open"
                          checked={shiftType === "open"}
                          onChange={() => showField("open")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio1"
                          style={{ fontSize: "14px" }}
                        >
                          Open
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio2"
                          {...register("shiftType", { required: true })}
                          value="unassigned"
                          checked={shiftType === "unassigned"}
                          onChange={() => showField("unassigned")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio2"
                          style={{ fontSize: "15px" }}
                        >
                          Unassigned
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio3"
                          {...register("shiftType", { required: false })}
                          value="assigned"
                          checked={shiftType === "assigned"}
                          onChange={() => showField("assigned")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio3"
                          style={{ fontSize: "15px" }}
                        >
                          Assigned To
                        </label>
                      </div>

                      {errors.shiftType && (
                        <span style={{ color: "red" }}>
                          This field is required
                        </span>
                      )}
                    </div>
                    <div className="col-md-4"></div>
                    {shiftType == "assigned" && (
                      <div className="col-md-8 mt-2">
                        <div
                          className="position-relative"
                          onClick={() => handleShiftSelect()}
                        >
                          {(props.typeshift == "generic" ||
                            props.typeshift == "client" ||
                            props?.editTaskData?.evdata == "open") && (
                            <Select
                              isMulti={true}
                              options={filteredResultsTeam}
                              onChange={handleCareteamSelect}
                            />
                          )}
                          {props.typeshift == "" &&
                            props?.editTaskData?.evdata !== "open" && (
                              <Select
                                isMulti={true}
                                options={filteredResultsTeam}
                                value={assignedCareTeamData}
                                onChange={handleCareteamSelect}
                              />
                            )}
                          {errors.assign_to && (
                            <span style={{ color: "red" }}>
                              This field is required
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <div className="instructions_box">
                  <textarea
                    placeholder="Instructions (Optional)"
                    rows="12"
                    value={instruction}
                    onChange={(e) => setinstruction(e.target.value)}
                    className="form-control"
                  ></textarea>
                  {/* <div className="action_icon">
                    <button className="btn camera">
                      <BsFillCameraFill />
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
            <hr />

            {/* <EditTask
              startingTime={watch('startTime', '')}
              endTime={watch('endTime', '')}
              onAddTask={onAddTaskHandler}
              updateData={updateData}
              arrTaskLength={onarrTaskLengthHandler}
              isAddTaskValid={isAddTaskValid}
              reverse={reverse}
            /> */}

            <div className="row">
              <div className="col-md-12 text-center">
                <button
                  type="submit"
                  className="submit_b task_btn_size"
                  onClick={() => setIsAddTaskValid(true)}
                >
                  {buttonText}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
export default EditCreateShiftTask;

const sortArrayByKeyAsc = (arr, key) => {
  return [...arr].sort((a, b) => {
    const valA = Number(a[key]);
    const valB = Number(b[key]);
    return valA - valB;
  });
};
const sortArrayByKeyDesc = (arr, key) => {
  return [...arr].sort((a, b) => {
    const valA = Number(a[key]);
    const valB = Number(b[key]);
    return valB - valA;
  });
};
